import {EventEmitter} from '@angular/core';

export interface IStorageSubscription {
    key: string;
    value?: any;
}

export abstract class StorageService {

    protected _changeEmitter = new EventEmitter<IStorageSubscription>();

    get changeKey() {
        return this._changeEmitter;
    }

    constructor(protected storage: any) {
    }

    clear() {
        if (typeof this.storage.clear === 'function') {
            this.storage.clear();
        } else {
            this.storage = {};
        }
    }

    get(key: string): any {
        return this.storage[key];
    }

    getJson(key: string): any {
        try {
            return JSON.parse(this.get(key));
        } catch (e) {
        }
    }

    set(key: string, value: any) {
        this.storage[key] = value;
        this._changeEmitter.emit({ key, value });
    }

    setJson(key: string, value: any) {
        this.set(key, JSON.stringify(value));
    }

    remove(key: string) {
        delete this.storage[key];
        this._changeEmitter.emit({ key });
    }

}